import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {SymbolStates} from "../../reels/symbols/BasicSymbol";
import {XNudgeSymbol} from "../../reels/symbols/XNudgeSymbol";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XSplitNudgePresentation implements SimplePresentation {
    name: string = "XSplitNudgePresentation";
    private _xsnTL: gsap.core.Timeline;

    shouldRun(): boolean {
        return XwaysHoarder2.model.xnPresent.includes(true);
    }

    start(controller: SimplePresentationRunnerController): void {
        this._xsnTL = gsap.timeline({
            onStart: () => {
                if (XwaysHoarder2.model.isDefinitelyADeadSpin)
                    this._xsnTL.timeScale(2);
            },
            onComplete: () => {
                this._xsnTL.timeScale(1);
                controller.setSkipCallback();
                controller.finish();
            }
        });




        let nudgeSoundPlayed: boolean = false;

        let xnArrowSoundPlayed: boolean = false;

        XwaysHoarder2.model.xnPresent.forEach((value: boolean, reelNo: number) => {//creating logic
            if (value) {
                const oneNudgeTL: gsap.core.Timeline = gsap.timeline();
                const xnSym: XNudgeSymbol = <XNudgeSymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(XwaysHoarder2.model.xnOrginalPos[reelNo]).positionable;
                const possibleSteps: number = 3 - xnSym.symbolHeight;
                const startIndex: number = xnSym.symID == 0 ? xnSym.symID + xnSym.symbolHeight : xnSym.symID - 1;
                let totalSteps: number = 0;
                const convertSymIndexes: number[] = [];
                if (possibleSteps > 0) {
                    if (xnSym.nudgeDirectionDown) {

                        for (let i: number = startIndex; i < 3; i++) {
                            if (!(["SC", "SSC", "XN", "XS", "XW", "LT"].includes(XwaysHoarder2.model.reels[reelNo][i]))) {
                                // console.log("possible nudge pos ", i);
                                totalSteps++;
                                convertSymIndexes.push(i);
                            } else {
                                break;
                            }

                        }
                    } else {
                        for (let i: number = startIndex; i > -1; i--) {
                            if (!(["SC", "SSC", "XN", "XS", "XW", "LT"].includes(XwaysHoarder2.model.reels[reelNo][i]))) {
                                //  console.log("possible nudge pos ", i);
                                totalSteps++;
                                convertSymIndexes.push(i);
                            } else {
                                break;
                            }

                        }

                    }

                    if (totalSteps > 0) {//main animation
                        oneNudgeTL.add(() => {
                            xnSym.moveToOverlayLayer();
                        }, 0);
                        oneNudgeTL.add(xnSym.blueArrowHighlight());
                        if(!xnArrowSoundPlayed) {
                            oneNudgeTL.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_NUDGE_ARROW);
                            }, "<");
                            xnArrowSoundPlayed = true;
                        }
                        oneNudgeTL.add(xnSym.getStateAnimation(SymbolStates.NUDGE));

                        if(!nudgeSoundPlayed) {
                            oneNudgeTL.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_NUDGE_NUDGE);
                            }, "<");
                            nudgeSoundPlayed = true;
                        }

                        oneNudgeTL.add(xnSym.moveSpineAnimation(totalSteps, xnSym.nudgeDirectionDown), "<");
                        oneNudgeTL.add(oneNudgeTL.addLabel("nudgeComplete"));
                        oneNudgeTL.add(() => {
                            for (let i: number = 0; i < convertSymIndexes.length; i++) {
                                XwaysHoarder2.reelView.reels[xnSym.reel.id].replaceSymOnReel(convertSymIndexes[i], "XN");
                                const XNSym:XNudgeSymbol=<XNudgeSymbol>XwaysHoarder2.reelView.reels[xnSym.reel.id].model.getVisibleSymbolAt(convertSymIndexes[i]).positionable;
                                XNSym.getStateAnimation(SymbolStates.REMOVED);
                                XNSym.moveToOverlayLayer();
                            }
                            // xnSym.moveToNormalLayer();
                        }, ">");
                        if (totalSteps == 1 && xnSym.symbolHeight == 1) {
                            oneNudgeTL.add(this.playXNStopAnim(xnSym, true));
                        }
                    } else {
                        if (xnSym.symbolHeight !== 3 && XwaysHoarder2.model.xnToNudge[reelNo]) {
                            oneNudgeTL.add(this.playXNStopAnim(xnSym, false), 0);
                        }

                    }

                }

                this._xsnTL.add(oneNudgeTL, 0);

                this._xsnTL.addLabel("oneEnding");

                if (XwaysHoarder2.model.checkRespinScenario) {
                    const xnXsTL: gsap.core.Timeline = gsap.timeline();
                    xnXsTL.to(this, {duration: 0.05}, 0);
                    convertSymIndexes.forEach((symId: number) => {
                        const symData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(symId);
                        const changeTl: gsap.core.Timeline = gsap.timeline();
                        changeTl.to(this, {duration: 0.02});//TODO add animation when it is made
                        changeTl.add(() => {
                            XwaysHoarder2.reelView.reels[xnSym.reel.id].replaceSymOnReel(symId, "XS", true, SymbolStates.NORMAL, "_revealed")
                        }, ">");
                        xnXsTL.add(changeTl, 0.05);
                    });
                    xnXsTL.add(() => {
                        for (let i: number = 0; i < xnSym.symbolHeight; i++) {
                            XwaysHoarder2.reelView.reels[xnSym.reel.id].replaceSymOnReel(xnSym.symID + i, "XS", true, SymbolStates.NORMAL, "_revealed")
                        }
                    }, 0.05);
                    this._xsnTL.add(xnXsTL, ">");
                }
            }
        });
        controller.setSkipCallback(() => this.onNudgeSkip());

    }

    private playXNStopAnim(xnSymbol: XNudgeSymbol, specialCase: boolean): gsap.core.Timeline {
        const shieldTl: gsap.core.Timeline = gsap.timeline();
        const xnstop: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XN_STOP));
        const animName: string = xnSymbol.nudgeDirectionDown ? "Shield_Bot" : "Shield_Top";
        xnstop.position.x = XwaysHoarder2Statics.symbolWidth * 0.5;
        xnstop.position.y = XwaysHoarder2Statics.symbolHeight * 0.5 + (xnSymbol.nudgeDirectionDown ? xnSymbol.position.y + (xnSymbol.symbolHeight - 1) * 200 : xnSymbol.position.y);
        if (specialCase) {
            xnstop.position.y += xnSymbol.nudgeDirectionDown ? 200 : -200;
        }
        xnstop.visible = false;
        shieldTl.add(() => {
            XwaysHoarder2.reelView.reels[xnSymbol.reel.id].layers.lockOverlay.addChild(xnstop);
            xnstop.visible = true;
        }, 0.005);
        shieldTl.add(SpineGSAPWrapper.createTimelineForAnimation(xnstop, 0, animName, false), 0);
        shieldTl.add(() => {
            XwaysHoarder2.reelView.reels[xnSymbol.reel.id].layers.lockOverlay.removeChild(xnstop);
        });
        return shieldTl;
    }

    private onNudgeSkip(): void {
        this._xsnTL.totalProgress(1);
    }
}